import contact_details from "./stages/contact_details";
import tickets from "./stages/tickets";
import workshops from "./stages/workshops";
import extras from "./stages/extras";
import attendees from "./stages/attendees";
import confirmation from "./stages/confirmation";

/**
 * All the stages the membership form uses
 */
export const stages = {
    contact_details : contact_details,
    tickets         : tickets,
    workshops       : workshops,
    extras          : extras,
    attendees       : attendees,
    confirmation    : confirmation
}